module.exports = __webpack_public_path__ + "img/category-sport.7a32de23.png";